import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import ptBRCommon from '../locales/pt-BR/common.json';
import ptBRAuth from '../locales/pt-BR/auth.json';
import ptBRFiles from '../locales/pt-BR/files.json';
import ptBRFolders from '../locales/pt-BR/folders.json';
import ptBRUsers from '../locales/pt-BR/users.json';
import ptBRAudit from '../locales/pt-BR/audit.json';
import ptBRSettings from '../locales/pt-BR/settings.json';
import ptBRShares from '../locales/pt-BR/shares.json';
import ptBRVideo from '../locales/pt-BR/video.json';

import enUSCommon from '../locales/en-US/common.json';
import enUSAuth from '../locales/en-US/auth.json';
import enUSFiles from '../locales/en-US/files.json';
import enUSFolders from '../locales/en-US/folders.json';
import enUSUsers from '../locales/en-US/users.json';
import enUSAudit from '../locales/en-US/audit.json';
import enUSSettings from '../locales/en-US/settings.json';
import enUSShares from '../locales/en-US/shares.json';
import enUSVideo from '../locales/en-US/video.json';

import esESCommon from '../locales/es-ES/common.json';
import esESAuth from '../locales/es-ES/auth.json';
import esESFiles from '../locales/es-ES/files.json';
import esESFolders from '../locales/es-ES/folders.json';
import esESUsers from '../locales/es-ES/users.json';
import esESAudit from '../locales/es-ES/audit.json';
import esESSettings from '../locales/es-ES/settings.json';
import esESShares from '../locales/es-ES/shares.json';
import esESVideo from '../locales/es-ES/video.json';

export const resources = {
  'pt-BR': {
    common: ptBRCommon,
    auth: ptBRAuth,
    files: ptBRFiles,
    folders: ptBRFolders,
    users: ptBRUsers,
    audit: ptBRAudit,
    settings: ptBRSettings,
    shares: ptBRShares,
    video: ptBRVideo,
  },
  'en-US': {
    common: enUSCommon,
    auth: enUSAuth,
    files: enUSFiles,
    folders: enUSFolders,
    users: enUSUsers,
    audit: enUSAudit,
    settings: enUSSettings,
    shares: enUSShares,
    video: enUSVideo,
  },
  'es-ES': {
    common: esESCommon,
    auth: esESAuth,
    files: esESFiles,
    folders: esESFolders,
    users: esESUsers,
    audit: esESAudit,
    settings: esESSettings,
    shares: esESShares,
    video: esESVideo,
  },
};

export const supportedLanguages = [
  { code: 'pt-BR', name: 'Português (Brasil)', flag: '🇧🇷' },
  { code: 'en-US', name: 'English (US)', flag: '🇺🇸' },
  { code: 'es-ES', name: 'Español (España)', flag: '🇪🇸' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    defaultNS: 'common',
    ns: ['common', 'auth', 'files', 'folders', 'users', 'audit', 'settings', 'shares', 'video'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
